import React, { Component } from 'react';
import './PlayerLog.css'
import { post, get } from '../../Utils/request'
import { Link } from 'react-router-dom';
import { Button,message } from 'antd';
class PlayerLog extends Component {
    constructor(props){
        super(props);
        this.state={
            userName:'',
            userPassword:'',
            unnameHelp:'',
            upwdHelp:''
        }
    }
    //监听input数据 保存到state中
    changeUsername(e){
        let uname = e.target.value;
        this.setState({
            userName:uname
        },()=>{
            console.log(this.state.userName)
        }) 
        
    }

    changePassword(e){
        let upwd = e.target.value;
        this.setState({
            userPassword: upwd
        })
    }

 
    //点击登录按钮 触发后台接口提供的验证，对数据的处理等方法
     handleClick(){
         if(this.state.userName === ""||this.state.userName === null){
            //  this.setState({
            //      unameHelp:"用户名不可为空"
            //  })
            message.warn('用户名不能为空',3)
            
            //  this.refs.username.value=this.state.unameHelp
         }else if(this.state.userPassword === ""||this.state.userPassword === null){
            //  this.setState({
            //      unameHelp:"",
            //      upwdHelp:"密码不可为空"
            //  })
            //  this.refs.username.value=this.state.unameHelp
            //  this.refs.password.value=this.state.upwdHelp
            message.warn('密码不能为空',3)
            
         }else{//清除提示文字
            //  this.setState({
            //     unameHelp: "",
            //     upwdHelp: ""
            //  })
            //  this.refs.username.value=this.state.unameHelp
            //  this.refs.password.value=this.state.upwdHelp
            post('/player/login', {
                player_name: this.state.userName,
                password: this.state.userPassword,
            }) 
            .then(res => {
               
                    window.localStorage.token = res.token
                    window.localStorage.userId = 'player'
                    message.success('登陆成功')
                    setTimeout(() => {
                        this.props.changeF()
                        this.props.push("/personalinformation")
                    }, 300);
            })
         };
            // post('/manager/login', {
            //     player_name: this.state.user_name,
            //     password: this.state.password,
            // }) 
            // .then(res => {
            //     if(res.code*1 === 200){
            //         window.localStorage.token = res.data.token
            //         alert(res.message)
            //         this.props.changeF()
            //     }else{
            //         alert('登陆失败')
            //     }
                
            // })
         
    

     }

    render() {
        return (
            <>
            <div  className="Log" >
                <div className="smectite" onClick={this.props.changeF.bind(this)}></div>
                <div className="Log-container">
                    <div  className="Log-wrapper">

                        <div className="title-match">中国公共关系行业最佳案例大赛</div>
                        <div className="left-line"></div> 
                        <span className="middle-text-player">选手登录</span>
                        <div className="right-line"></div> 

                        <div className="username-content">
                            <div className="user-logo-content">
                                <img className="user-logo" src="/img/1.2.png"/>
                            </div>
                            <input type="text" name="username" ref="username" onChange={this.changeUsername.bind(this)} className="cin-name" placeholder="请输入用户姓名" />
                        </div>

                        <div className="password-content">
                            <div className="password-logo-content">
                                <img className="lock-logo" src="/img/4.2.png"/>
                            </div>
                            <input type="password" name="password"  ref="password" onChange={this.changePassword.bind(this)} className="cin-password" placeholder="请输入密码" />
                        </div>

                        {/* <button className="to-login" onClick={this.props.changeF}>登录</button> */}
                        <div disabled={this.state.isGo} name="sub" className="to-login" onClick={this.handleClick.bind(this)} >登录</div>
                        {/* <input  id="auto-login" className="auto-login" type="checkbox" />
                        <label htmlFor="auto-login" className="to-auto-login">下次自动登录</label> */}
                        <Link className="forget-password" to="/tofindpassword">忘记密码</Link>
                        {/* <button className="forget-password"  >忘记密码</button> */}
                        <span className="divider">|</span>
                        <Link className="to-reg" to="/reg" onClick={this.props.changeF} >注册</Link>
                        

                    </div>
                    
                </div>
            </div>
            
        </>
        );
    }
}

export default PlayerLog;